// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "../views/RedirectoLogin";
import MyBilling from "../containers/billings/MyBilling";

class Project extends Component<*> {
  render(): * {
    return (
      <UserAuth
        principal="online-user-admin"
        unAuthChildren={<RedirectoLogin />}
      >
        <div className="app-main">
          <MyBilling />
        </div>
      </UserAuth>
    );
  }
}

export default Project;
